import { HttpErrorResponse } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { AppErrorHandlerService } from '../../services/app-error-handler/app-error-handler.service'
import { LogService } from '../../services/log.service'
import * as FeatureMYDActions from './feature-myd.actions'
import { FeatureMYDService } from './feature-myd.service'
import { UtilityService } from '../../services/utility.service'

@Injectable()
export class FeatureMYDEffects {
   private _cn = this.constructor.name
   private _actions$ = inject(Actions)
   private _logService = inject(LogService)
   private _service = inject(FeatureMYDService)
   private _utilityService = inject(UtilityService)
   private _errorHandlerService = inject(AppErrorHandlerService)

   actionSearchProject$ = createEffect(() =>
      this._actions$.pipe(
         ofType(FeatureMYDActions.searchYourDraft),
         switchMap((action) =>
            this._service.searchDrafts(action.request).pipe(
               tap((res) => this._logService.debug(this._cn, 'searchYourDraft effect', 'response:', res)),
               map((result) => FeatureMYDActions.searchYourDraftSuccess({ result })),
               catchError((error: HttpErrorResponse) => {
                  return of(FeatureMYDActions.searchYourDraftFailure({ error: error }))
               })
            )
         )
      )
   )

   retriveDraftCount$ = createEffect(() =>
      this._actions$.pipe(
         ofType(FeatureMYDActions.getNumberOfYourDrafts),
         switchMap(() =>
            this._service.getNumberOfYourDrafts().pipe(
               map((count) => FeatureMYDActions.getNumberOfYourDraftsSuccess({ count })),
               catchError((error: HttpErrorResponse) => {
                  return of(FeatureMYDActions.getNumberOfYourDraftsFailure({ error: error }))
               })
            )
         )
      )
   )

   private _actionsForErrorNotificationMessage = [FeatureMYDActions.searchYourDraftFailure, FeatureMYDActions.getNumberOfYourDraftsFailure]

   listenAllFailureAction$ = createEffect(
      () =>
         this._actions$.pipe(
            ofType(...this._actionsForErrorNotificationMessage),
            map((errorResponse) => this._errorHandlerService.handleError(errorResponse.error))
         ),
      { dispatch: false }
   )
}
